module.exports = __webpack_public_path__ + "static/media/extendAccess.6323be1c.svg";